/* Goloka V3 About + Contact: reveal-on-scroll (once), click-to-play film, inline form validation. */
(function () {
  if (window.__v3page) return;
  window.__v3page = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.v3p-reveal');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('v3p-rv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.03 });
    els.forEach(function (el) { io.observe(el); });
  }

  function film() {
    document.querySelectorAll('[data-v3p-film]').forEach(function (box) {
      var video = box.querySelector('video');
      var btn = box.querySelector('[data-v3p-play]');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        video.controls = true;
        box.classList.add('is-playing');
        btn.hidden = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* user can press play in the native controls */ });
      });
    });
  }

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = /^[+\d][\d\s()-]{6,}$/;
  function check(kind, value) {
    value = (value || '').trim();
    if (kind === 'email') {
      if (!value) return 'Enter your email address.';
      if (!EMAIL.test(value)) return 'Enter a valid email address, like name@example.com.';
    } else if (kind === 'message') {
      if (!value) return 'Tell us how we can help.';
    } else if (kind === 'phone') {
      if (value && !PHONE.test(value)) return 'Enter a valid phone number, or leave this blank.';
    }
    return '';
  }
  function show(input, msg) {
    var err = document.getElementById(input.id + '-err');
    if (!err) return;
    if (msg) {
      err.textContent = msg; err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', err.id);
    } else {
      err.textContent = ''; err.hidden = true;
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }
  function form() {
    var f = document.getElementById('v3p-contact-form');
    if (!f) return;
    var inputs = Array.prototype.slice.call(f.querySelectorAll('[data-v3p-validate]'));
    inputs.forEach(function (input) {
      var kind = input.getAttribute('data-v3p-validate');
      input.addEventListener('blur', function () { show(input, check(kind, input.value)); });
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) show(input, check(kind, input.value)); });
    });
    f.addEventListener('submit', function (e) {
      var first = null;
      inputs.forEach(function (input) {
        var msg = check(input.getAttribute('data-v3p-validate'), input.value);
        show(input, msg);
        if (msg && !first) first = input;
      });
      if (first) { e.preventDefault(); first.focus(); }
    });
    var focusTarget = f.querySelector('[data-v3p-success], [data-v3p-formerrors]');
    if (focusTarget) focusTarget.focus();
  }

  function init() { reveal(); film(); form(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
